import React, { useState } from "react";
import Base from "../core/Base";
import {
  Box, Typography, Paper, TextField, Button, Grid, Alert, CircularProgress,
  FormGroup, FormControlLabel, Checkbox, Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { isAutheticated } from "../auth/helper";
import { addSubAdmin } from "./helper/adminapicall";

const GRANTABLE_PAGES = [
  { key: "subadmins",  label: "Subadmins" },
  { key: "server",     label: "Server Health" },
  { key: "redis",      label: "Redis Monitor" },
  { key: "login-logs", label: "Login Logs" },
  { key: "sources",    label: "Feed Sources" },
  { key: "companies",  label: "Companies" },
];

const AddSubadmin = () => {
  const { admin, token } = isAutheticated();
  const [values, setValues] = useState({
    name: "", lastname: "", phone: "", email: "",
    password: "", confirmPassword: "", error: "", loading: false, success: false,
  });
  const { name, lastname, phone, email, password, confirmPassword, error, loading, success } = values;
  const [allowedPages, setAllowedPages] = useState([]);

  const handleChange = (field) => (e) => setValues({ ...values, error: "", [field]: e.target.value });
  const togglePage   = (key) => setAllowedPages((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );

  const onSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) return setValues({ ...values, error: "Passwords do not match" });
    setValues({ ...values, error: "", loading: true });
    addSubAdmin(admin._id, token, { name, lastname, phone, email, password, allowedPages })
      .then((data) => {
        if (data?.error) setValues({ ...values, error: data.error, loading: false });
        else setValues({ name: "", lastname: "", phone: "", email: "", password: "", confirmPassword: "", error: "", loading: false, success: true });
      })
      .catch(() => setValues({ ...values, error: "Request failed", loading: false }));
  };

  return (
    <Base>
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 2 }}>
        <Button startIcon={<ArrowBackIcon />} component={Link} to="/subadmins" sx={{ color: "text.secondary" }}>
          Back
        </Button>
        <Box>
          <Typography variant="h5">Add Subadmin</Typography>
          <Typography variant="body2" color="text.secondary">Create a new subadmin account</Typography>
        </Box>
      </Box>

      <Paper elevation={0} sx={{ p: 3, border: "1px solid", borderColor: "divider", borderRadius: 3, maxWidth: 640 }}>
        {error   && <Alert severity="error"   sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>Subadmin created successfully.</Alert>}

        <Box component="form" onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="First Name" value={name} onChange={handleChange("name")} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="Last Name"  value={lastname} onChange={handleChange("lastname")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="Email" type="email" value={email} onChange={handleChange("email")} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="Phone" value={phone} onChange={handleChange("phone")} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="Password" type="password" value={password} onChange={handleChange("password")} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth size="small" label="Confirm Password" type="password" value={confirmPassword} onChange={handleChange("confirmPassword")} required />
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>Page Access</Typography>
              <Typography variant="caption" color="text.secondary">Select which admin pages this subadmin can access.</Typography>
              <FormGroup row sx={{ mt: 1 }}>
                {GRANTABLE_PAGES.map((pg) => (
                  <FormControlLabel
                    key={pg.key}
                    control={<Checkbox checked={allowedPages.includes(pg.key)} onChange={() => togglePage(pg.key)} size="small" />}
                    label={<Typography variant="body2">{pg.label}</Typography>}
                  />
                ))}
              </FormGroup>
            </Grid>

            <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
              <Button component={Link} to="/subadmins" sx={{ color: "text.secondary" }}>Cancel</Button>
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={20} color="inherit" /> : "Create Subadmin"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Base>
  );
};

export default AddSubadmin;
